/* eslint-disable */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth_store';

export const AgencySettings = defineStore('AgencySettings', {
  state: ()=>({
    textareaLimitsPr: null,
  }),
  getters: {
  },
  actions: {
    textareaLimits(){
      if (this.textareaLimitsPr) return this.textareaLimitsPr
      let url = `/v1/agency_settings/textarea_limits`
      if(useAuthStore().isPublic) url = `${window.location.pathname}/textarea_limits` // /pub/form/0COydz6l9kyS5Nzn/textarea_limits

      return this.textareaLimitsPr=axios.get(url).then(r=>{
        const data = r.data.data
        if (data){
          return parseInt(data)
        }else{
          return null
        }
      })
    }
  }
});